module.exports = __webpack_public_path__ + "img/SC Logo_CMYK.9ee3c5ec.jpg";